import moment from "moment";

const state = {
  timeNow: moment(),
  timeInterval: null,
  date: "1970-01-01",
  week: 1,
  day: "mon"
};

const mutations = {
  SET_TIME(state) {
    state.timeNow = moment();
  },
  SET_DATE(state) {
    state.date = moment().format("YYYY-MM-DD");
    state.week = moment().isoWeek().toString();
    state.day = moment().format("ddd").toLowerCase();
  },
  START_TIME_INTERVAL(state, interval) {
    state.timeInterval = interval;
  },
  STOP_TIME_INTERVAL(state) {
    state.timeInterval = null;
  }
};

const actions = {
  startTimer({ state, commit, dispatch, rootState }) {

    let counter = 0;
    commit("START_TIME_INTERVAL", setInterval(() => {

      commit("SET_TIME");
            
      // Day changed
      if (state.date !== state.timeNow.format("YYYY-MM-DD")) {
        commit("SET_DATE");
        if (rootState.Stats.statId) dispatch("downloadStatistics", rootState.Stats.statId);
      } else if (counter % 100 === 0 && 
                       rootState.Stats.statId &&
                       rootState.Videos.selectedVideo === null) {
        dispatch("updateStatistics");
      }

      counter += 1;

      if (counter % 10 === 0) {
        dispatch("checkScheduleForTrigger").then(scheduledClass => {
          if (scheduledClass !== false) {
            dispatch("playVideo", scheduledClass);
          }
        });
      }

      if (counter % 15 === 0) {
        dispatch("setNextClass");
      }

      if (counter === 300) {
        dispatch("clearErrors");
        counter = 0;
      }

    }, 1000));

  },
  stopTimerr({ commit }) {
    commit("STOP_TIME_INTERVAL");
  },
  startDisplayOffCountdown({ commit }) {
    const obj = getters.getCurrentDaySchedule.find(
      scheduledItem => {
        if (
          scheduledItem.triggered === undefined ||
                    scheduledItem.triggered === false
        ) {
          const scheduledItemTime = moment(scheduledItem.time, "HH:mm");
          const timeNow = moment();
          if (
            scheduledItemTime.diff(timeNow, "seconds") < 540 &&
                        scheduledItemTime.diff(timeNow, "seconds") > 0
          ) {
            return true;
          } 
          return false;
          
        }
        return false;
      }
    );
    if (obj === undefined) {
      if (this.$store.getters.getDisplayExists) {
        if (state.displayIsOn === false) {
          commit("SET_DISPLAY_IS_ON", true);
        }

        if (state.timeout === null) {

          const t = setTimeout(() => {
            commit("STOP_TIMER");
            commit("SET_DISPLAY_IS_ON", false);

          }, 1000 * 60 * 1);

          commit("SET_TIMER", t);
        }
      }
    }
  }

};

const getters = {
  getCurrentTime(state) {
    return state.timeNow.format("HH:mm");
  },
  getDayAndWeek(state) {
    return {
      day: state.day,
      week: state.week
    };
  }
};


export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Timer.js